const VEHICLE_LIST_SEPARATOR = /[\s,;]+/;

const splitVehicleListValue = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.flatMap(splitVehicleListValue);
  }

  if (value === undefined || value === null) {
    return [];
  }

  return String(value).split(VEHICLE_LIST_SEPARATOR);
};

export const parseVehicleListTags = (value: unknown) => {
  const seen = new Set<string>();

  return splitVehicleListValue(value).reduce<string[]>((result, item) => {
    const normalized = item.trim().toUpperCase();

    if (!normalized || seen.has(normalized)) {
      return result;
    }

    seen.add(normalized);
    result.push(normalized);
    return result;
  }, []);
};
